import {BaseService} from "./baseService";
import {AbstractDBContent, Content, ContentKey, ContentService, DBContentMode} from "./content";


export interface Page<DateType = string> {
    createdAt: DateType;
    id: string;
    slug: string;
    title: string | null;
    updatedAt: DateType;
    seoTitle: string | null;
    seoDescription: string | null;
    seoSchema: string | null;
}

export type PageContentMode = DBContentMode;

export interface PageContent<DateType = string> extends AbstractDBContent<PageContentMode, DateType> {
    page?: Pick<Page<DateType>, "id"> | null;
}

// export type PageContentCreate = Omit<PageContent, "id" | "createdAt" | "page" | "updatedAt"> & Required<Pick<PageContent, "page">>;

export class PageService extends BaseService {
    // public static async createContent(data: PageContentCreate): Promise<PageContent>
    // {
    //     const connection = this.createAdminConnection();
    //     const response = await connection.post<PageContent>("/contents", {
    //         ...data,
    //     });
    //     return response.data;
    // }

    public static async getBareContentByPageId<Keys extends readonly ContentKey[]>(pageId: string, keys: Keys): Promise<Content<Keys[number]>> {
        const content = await this.getContentByPageId(pageId);
        return ContentService.get(content, keys, message => console.warn(`[PageService.getBareContentByPageId][page = ${pageId}]: ${message}`));
    }

    public static async getBareContentBySlug<Keys extends readonly ContentKey[]>(pageSlug: string, keys: Keys): Promise<Content<Keys[number]>> {
        const page = await this.getBySlug(pageSlug);
        if (page === undefined) {
            return {} as Content<Keys[number]>;
        }

        return this.getBareContentByPageId(page.id, keys);
    }

    public static async getBySlug(slug: string): Promise<Page | undefined> {
        const pages = await this.getByParams({
            where: {
                slug: {
                    equals: slug
                }
            }
        });

        return pages.pop();
    }

    public static async getContentByPageId(pageId: string): Promise<PageContent[]> {
        const response = await this.getData<PageContent[]>("/contents", {

            where: {
                page: {
                    id: pageId
                }
            },
            orderBy: {
                order: 'asc'
            }

        });
        // console.log({response})
        return response;
    }

    public static async getContent(pageOrSlug: Page | string): Promise<PageContent[]> {
        const page = typeof pageOrSlug === "string" ? await this.getBySlug(pageOrSlug) : pageOrSlug;

        if (page === undefined) {
            return [];
        }

        const response = await this.getData<PageContent[]>("/contents", {

            where: {
                page: {
                    id: page.id
                }
            },
            orderBy: {
                order: 'asc'
            }

        });
        // console.log({response})
        return response;
    }

    private static async getByParams(params: any): Promise<Page[]> {
        return this.getData<Page[]>("/pages", params);
        // const r = await fetch(`${process.env.API_URL}/pages`, {
        //     method: 'GET',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(params)
        // });
        // return r.json();

        // const response = await this.connection.get<Page[]>("/pages", { params });
        // return response.data;
    }

    // public static async synchronizeContent<Keys extends readonly ContentKey[]>(pageOrSlug: Page | string, newContent: Content<Keys[number]>, keys: Keys, options?: ContentSynchronizeOptions): Promise<void>
    // {
    //     const page = typeof pageOrSlug === "string" ? await this.getBySlug(pageOrSlug) : pageOrSlug;
    //
    //     if (page === undefined)
    //     {
    //         throw new Error(`Page with slug ${pageOrSlug} not found`);
    //     }
    //
    //     let adminConnection: AxiosInstance | undefined;
    //
    //     ContentService.synchronize({
    //         keys,
    //         newContent,
    //         oldContent: await this.getContent(page),
    //         onCreate: async (key, item, order) =>
    //         {
    //             adminConnection = adminConnection ?? this.createAdminConnection();
    //             await adminConnection.post("/contents", {
    //                 data: item.data,
    //                 key,
    //                 mode: ContentTypeMap[item.type] as PageContentMode,
    //                 order,
    //                 page: {
    //                     id: page.id
    //                 }
    //             } satisfies PageContentCreate);
    //         },
    //         onChange: async (id, item, order) =>
    //         {
    //             adminConnection = adminConnection ?? this.createAdminConnection();
    //             await adminConnection.put(`/contents/${id}`, {
    //                 data: item.data,
    //                 mode: ContentTypeMap[item.type] as PageContentMode,
    //                 order
    //             });
    //         },
    //         onDelete: async id =>
    //         {
    //             adminConnection = adminConnection ?? this.createAdminConnection();
    //             await adminConnection.delete(`/contents/${id}`);
    //         },
    //         truncateFirst: options?.truncateFirst
    //     });
    // }
}
